import RassdLanding from './RassdLanding';

function App() {
  return <RassdLanding />;
}

export default App;